import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import RadioGroup from '../../form/radio-group';

class Component extends BaseComponent {
    componentDidMount() {
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.checkout.type != this.props.checkout.type) {
            return true;
        }

        return false;
    }

    render({ checkout, mode }) {
        if (checkout && checkout.order && !checkout.order.finalized && (
            !this.props.user.subscriptions || !this.props.user.subscriptions.drts
        )) {
            let rowClass = 'is-justified-center';

            if (this.props.user.kcs.total >= this.props.product.price.kc.current) {
                rowClass =`${rowClass} has-margin-30-top`;
            }

            return (
                <options-drts mode={mode}>
                    <row className={rowClass}>
                        <column className='is-7 is-12-mobile'>
                            <row>
                                <column className='is-1 is-2-mobile has-padding-5-top'>
                                    <RadioGroup
                                        name='checkout_option'
                                        checked={checkout.type == 'drts'}
                                        onChange={this.setPurchase}
                                    />
                                </column>
                                <column className='is-11 is-10-mobile'>
                                    <small className='has-text-eminence'>
                                        BEST VALUE! GET 3 TAROT READINGS PER DAY
                                    </small>
                                    <h4>
                                        {checkout.drts.info.product_name}
                                        <sup className='has-text-color-red'>*</sup>
                                    </h4>
                                    <small>
                                        <span className='has-text-color-red'>*</span>
                                        <i>This is a monthly charge</i>
                                    </small>
                                    <a
                                        className='is-block has-margin-10-top'
                                        href='/readings-reports/tarot-readings/daily-reflection/subscription'
                                        target='_blank'
                                        rel='noopener'
                                    >
                                        Learn More
                                    </a>
                                </column>
                            </row>
                        </column>
                    </row>
                </options-drts>
            );
        }

        return (<options-drts mode={mode} />);
    }

    setPurchase = () => {
        this.props.trackEvent([
            'Checkout',
            'LI Click',
            'Radio DRTS',
        ]);

        this.props.checkoutUpdate({
            type: 'drts',
            total: {
                current: parseFloat(this.props.checkout.drts.price.usd.current).toFixed(2),
                original: parseFloat(this.props.checkout.drts.price.usd.original).toFixed(2),
            },
        });
    }
}

const mapStateToProps = (state) => ({
    checkout: state.checkout,
    user: state.user,
    product: state.product,
});

const mapDispatchToProps = (dispatch) => ({
    checkoutUpdate: (payload) => dispatch({
        type: 'checkout:update',
        payload: payload,
    }),
    trackEvent: (payload) => dispatch({
        type: 'ga:event',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);